import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import AuthService from '../services/Authservice';
const Overlay = require('../components/overlay/overlay.vue.html');

@Component({
    components: {
        Overlay
    }
})
export default class Login extends Vue {
    username: string = ''; 
    password: string = '';
    validationCode: string = "";
    validationRequired: boolean = false;
    ser: AuthService = new AuthService();

    login() {
        this.$store.dispatch('clearMessages');
        this.$validator.validateAll()
            .then(resp => {
                if (resp)
                    this.ser.AuthUser(this.username, this.password, this.validationCode)
                        .then((response) => {
                            if (response) {  
                                this.routeUser();
                            }
                        }).catch(resp => {
                            if (resp.status && resp.status.statusCode === 401)
                                this.validationRequired = true;
                        });;
            })
           
    }

    routeUser() {
        //todo: SC put this back to if length == 1
        if (this.$store.state.user.applications.length <= 2)
            this.$router.push(this.$store.state.user.applications[0].path);
        else
            this.$router.push('/');
    }

    mounted() {
        this.$store.dispatch('clearMessages');
        this.$store.dispatch("isLoading", false);
    }
}



// WEBPACK FOOTER //
// ./ClientApp/src/login/login.ts